/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1673222400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Jan 09 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "orbit",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Setup",
          "depth": 0,
          "id": "setup"
        }, {
          "value": "Syncing activities",
          "depth": 0,
          "id": "syncing-activities"
        }, {
          "value": "Syncing members",
          "depth": 0,
          "id": "syncing-members"
        }, {
          "value": "Record matching",
          "depth": 1,
          "id": "record-matching"
        }, {
          "value": "Field mapping",
          "depth": 1,
          "id": "field-mapping"
        }, {
          "value": "Rate limits",
          "depth": 1,
          "id": "rate-limits"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      a: "a",
      img: "img",
      em: "em",
      h3: "h3"
    }, _provideComponents(), props.components), {EventSyncWarning} = _components;
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "setup",
        children: "Setup"
      }), "\n", _jsxs(_components.p, {
        children: ["To enable syncing with ", _jsx(_components.a, {
          href: "https://orbit.love",
          children: "Orbit"
        }), " first you need to get an authentication token. Go to your Account Settings (on the menu\nunder your profile picture) and click API Token:"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-orbit-token.png",
          alt: "API Token"
        })
      }), "\n", _jsx(_components.p, {
        children: "Then copy the value, and create a new Destination in Hightouch, selecting Orbit as the destination type. Lastly, paste\nthe API token into the field. Save the destination and it's ready to start syncing data."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-orbit-destination.png",
          alt: "Destination Orbit"
        })
      }), "\n", _jsx(_components.h2, {
        id: "syncing-activities",
        children: "Syncing activities"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing activities, Hightouch treats any records added to ", _jsx(_components.a, {
          href: "/getting-started/concepts",
          children: "your source"
        }), " as new activities and sends them to Orbit when your sync runs."]
      }), "\n", _jsx(EventSyncWarning, {
        type: "activity"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.em, {
          children: "Activities"
        }), " object from the drop down menu. Then you can\ndefine a static value for the title and the identity source for all the\nactivities, or define the column that will contain the information."]
      }), "\n", _jsx(_components.p, {
        children: "Lastly, choose the mappings for the columns in your model."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-orbit-sync.png",
          alt: "Orbit sync configuration"
        })
      }), "\n", _jsx(_components.h2, {
        id: "syncing-members",
        children: "Syncing members"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the ", _jsx(_components.em, {
          children: "Members"
        }), " object from the drop down menu."]
      }), "\n", _jsx(_components.h3, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsx(_components.p, {
        children: "Records can be matched from your source to your Orbit workspace by using the email field."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-orbit-recordmatching.png",
          alt: "Orbit sync configuration"
        })
      }), "\n", _jsx(_components.h3, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync columns from your source to Orbit Member fields."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-orbit-fieldmappings.png",
          alt: "Orbit sync configuration"
        })
      }), "\n", _jsx(_components.h3, {
        id: "rate-limits",
        children: "Rate limits"
      }), "\n", _jsx(_components.p, {
        children: "By default, Orbit limits 120 requests per IP per minute. If you experience slow syncs, please contact them to increase that limit,\nand let us know."
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
